import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import shared translations from common (market module)
import marketES from 'common/src/i18n/locales/es/market.json';
import marketEN from 'common/src/i18n/locales/en/market.json';
import marketZH from 'common/src/i18n/locales/zh/market.json';

import dashboardES from 'common/src/i18n/locales/es/dashboard.json';
import dashboardEN from 'common/src/i18n/locales/en/dashboard.json';
import dashboardZH from 'common/src/i18n/locales/zh/dashboard.json';

import commonMarketES from 'common/src/i18n/locales/es/common.json';
import commonMarketEN from 'common/src/i18n/locales/en/common.json';
import commonMarketZH from 'common/src/i18n/locales/zh/common.json';

// Import app-specific translations
import sidebarES from './es/sidebar.json';
import sidebarEN from './en/sidebar.json';
import sidebarZH from './zh/sidebar.json';
import receiverES from './es/receiver.json';
import receiverEN from './en/receiver.json';
import receiverZH from './zh/receiver.json';

const resources = {
  es: {
    sidebar: sidebarES,
    common: { ...commonMarketES },
    dashboard: dashboardES,
    market: marketES,
    receiver: receiverES,
  },
  en: {
    sidebar: sidebarEN,
    common: { ...commonMarketEN },
    dashboard: dashboardEN,
    market: marketEN,
    receiver: receiverEN,
  },
  zh: {
    sidebar: sidebarZH,
    common: { ...commonMarketZH },
    dashboard: dashboardZH,
    market: marketZH,
    receiver: receiverZH,
  },
};

// Custom language detector to read from Zustand persist storage
const zustandLanguageDetector = {
  type: 'languageDetector' as const,
  async: false,
  detect: () => {
    try {
      const stored = localStorage.getItem('language-storage');
      if (stored) {
        const parsed = JSON.parse(stored);
        return parsed.state?.language || 'zh';
      }
    } catch (error) {
      console.error('Error reading language from localStorage:', error);
    }
    return 'zh'; // Default to Chinese for importers app
  },
  init: () => {},
  cacheUserLanguage: () => {},
};

i18n
  .use(zustandLanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'zh',
    defaultNS: 'common',
    ns: ['common', 'sidebar', 'dashboard', 'market', 'receiver'],

    interpolation: {
      escapeValue: false, // React already escapes values
    },
  });

export default i18n;
